
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m2 9 26-6","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"m16.551 2.038-5.155 1.109a1.757 1.757 0 0 0-1.112.771c-.255.397-.343.88-.245 1.342L10.405 7 19 5l-.366-1.589a1.779 1.779 0 0 0-.76-1.123 1.74 1.74 0 0 0-1.323-.25Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 23v-9M20 23v-9M23.75 9H27l-1.715 19.325c-.08.949-.889 1.678-1.858 1.675H10.134c-.966 0-1.77-.729-1.85-1.675L7 13.11","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    